import { Flex, Select, Space, Switch, Typography } from 'antd';
import { FC } from 'react';

import { DomainVisitors } from '@/modules/Domains';
import { REDIRECT_MATCH_MODE_OPTIONS, REDIRECT_STATUS_CODE_OPTIONS, RedirectMatchMode } from '@/modules/Sites/Redirects';

interface Props {
  forDomainVisitor: DomainVisitors;
  active: boolean;
  statusCode: number;
  matchMode: RedirectMatchMode;
  disabled?: boolean;
  onChangeDomainVisitor: (value: DomainVisitors) => void;
  onChangeActivity: (checked: boolean) => void;
  onChangeStatusCode: (value: number) => void;
  onChangeMatchMode: (value: RedirectMatchMode) => void;
}

export const RedirectsConfig: FC<Props> = ({
  forDomainVisitor,
  active,
  statusCode,
  matchMode,
  onChangeDomainVisitor,
  onChangeActivity,
  onChangeStatusCode,
  onChangeMatchMode,
  disabled = false,
}) => {
  return (
    <Flex gap={ 16 } align="flex-start" wrap="wrap">
      <Flex gap={ 8 } align="flex-start" vertical>
        <Typography.Text type="secondary">Для відвідувача</Typography.Text>
        <Flex gap={ 8 } align="center">
          <Select
            value={ forDomainVisitor }
            style={{ width: 160 }}
            onChange={ onChangeDomainVisitor }
            disabled={ disabled }
            options={ [
              { value: DomainVisitors.Any, label: 'Будь-хто' },
              { value: DomainVisitors.GoogleBot, label: 'Google Bot' },
              { value: DomainVisitors.Person, label: 'Людина' },
            ] }
          />
          <Switch
            checked={ active }
            onChange={ onChangeActivity }
            disabled={ disabled }
            unCheckedChildren="Неактивні"
            checkedChildren="Активні"
          />
        </Flex>
      </Flex>

      <Space size={ 8 } direction="vertical">
        <Typography.Text type="secondary">Код редіректу</Typography.Text>
        <Select
          value={ statusCode }
          style={{ width: 220 }}
          onChange={ onChangeStatusCode }
          disabled={ disabled }
          options={ REDIRECT_STATUS_CODE_OPTIONS }
        />
      </Space>

      <Space size={ 8 } direction="vertical">
        <Typography.Text type="secondary">Режим співставлення</Typography.Text>
        <Select
          value={ matchMode }
          style={{ width: 220 }}
          onChange={ onChangeMatchMode }
          disabled={ disabled }
          options={ REDIRECT_MATCH_MODE_OPTIONS.map(({ value, label, description }) => ({
            value,
            label,
            title: description,
          })) }
        />
      </Space>
    </Flex>
  );
};
